import { Modal } from 'react-bootstrap';
import { createPortal } from 'react-dom';

function RatingPortal({ isOpen, children }) {
  return createPortal(
    <Modal show={isOpen} centered>
      <Modal.Body>{children}</Modal.Body>
    </Modal>,
    document.getElementById('modal')
  );
}

export { RatingPortal };
